import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-345">
      <Navigation data-id="element-346" />

      <main data-id="element-347">
        <Hero data-id="element-348" />
        <WhyUs data-id="element-349" />
        <Services data-id="element-350" />
        <FAQ data-id="element-351" />
        <Testimonials data-id="element-352" />
        <Consultation data-id="element-353" />
      </main>

      <Footer data-id="element-354" />
      <CookieBanner data-id="element-355" />
    </div>;
}